import axiosInstance from './axios';

export async function getAmbassadors() {
  const response = await axiosInstance.get('/ambassadors');
  return response.data;
}

export async function getAmbassadorById(id) {
  const response = await axiosInstance.get(`/ambassadors/${id}`);
  return response.data;
}

export async function getAmbassadorByUserId(userId) {
  const response = await axiosInstance.get(`/ambassadors/by-user/${userId}`);
  return response.data;
}

export async function getMyAmbassadorData() {
  const response = await axiosInstance.get('/ambassadors/my');
  return response.data;
}

export async function createAmbassador(data) {
  const response = await axiosInstance.post('/ambassadors', data);
  return response.data;
}

export async function updateAmbassador(id, data) {
  const response = await axiosInstance.put(`/ambassadors/${id}`, data);
  return response.data;
}

export async function deleteAmbassador(id) {
  const response = await axiosInstance.delete(`/ambassadors/${id}`);
  return response.data;
}

export async function processAmbassadorPayout(id, amount, note) {
  const response = await axiosInstance.post(`/ambassadors/${id}/payout`, { amount, note });
  return response.data;
}

export async function getAmbassadorPromoCodes(id) {
  const response = await axiosInstance.get(`/ambassadors/${id}/promo-codes`);
  return response.data;
}

export async function createPromoCode(ambassadorId, data) {
  const response = await axiosInstance.post(`/ambassadors/${ambassadorId}/promo-codes`, data);
  return response.data;
}

export async function updatePromoCode(id, data) {
  const response = await axiosInstance.put(`/ambassadors/promo-codes/${id}`, data);
  return response.data;
}

export async function deletePromoCode(id) {
  const response = await axiosInstance.delete(`/ambassadors/promo-codes/${id}`);
  return response.data;
}

export async function validatePromoCode(code) {
  const response = await axiosInstance.post('/ambassadors/validate-promo', { code });
  return response.data;
}

export async function validatePromoCodePublic(code) {
  const response = await axiosInstance.post('/ambassadors/validate-promo-public', { code });
  return response.data;
}

export const ambassadorsApi = {
  getAll: getAmbassadors,
  getById: getAmbassadorById,
  getByUserId: getAmbassadorByUserId,
  create: createAmbassador,
  update: updateAmbassador,
  delete: deleteAmbassador
};
